import { render } from "./Layer.vue?vue&type=template&id=52bbc8a4&scoped=true&ts=true"
import script from "./Layer.vue?vue&type=script&lang=ts"
export * from "./Layer.vue?vue&type=script&lang=ts"

import "./Layer.vue?vue&type=style&index=0&id=52bbc8a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bbc8a4"]])

export default __exports__